<h1 class="modal__header">How do I schedule a medical exam?</h1>
<div class="modal__text">
  <span *ngIf="isMMDirectPolicy">
    An examiner will contact you at the phone number provided to schedule a time and place convenient for you. If you
    haven't been contacted, you can call us at {{ channelInfo.phone }} or email us at
    <a href="mailto:{{ channelInfo.helpEmail }}">{{ channelInfo.helpEmail }}</a>
  </span>
  <span *ngIf="!isMMDirectPolicy">
    Your financial professional may schedule the medical exam on your behalf, or you may receive a call from the
    examiner so that you can arrange an appointment time. Contact your financial professional if you have questions.
  </span>
</div>
<div class="modal__actions">
  <button class="button button--blue button--primary modal__button" (click)="closeModal()">Exit</button>
</div>
